export const REQUEST_NOTIFICATIONS = "notifications/REQUEST_NOTIFICATIONS";
export const REQUEST_NOTIFICATIONS_SUCCESS =
  "notifications/REQUEST_NOTIFICATIONS_SUCCESS";
export const REQUEST_NOTIFICATIONS_FAIL =
  "notifications/REQUEST_NOTIFICATIONS_FAIL";

export const REQUEST_READ = "notifications/REQUEST_READ";
export const REQUEST_UPDATE_NOTIFICATIONS =
  "notifications/REQUEST_UPDATE_NOTIFICATIONS";
